import { render, staticRenderFns } from "./DocPDF.vue?vue&type=template&id=d134ac3a&scoped=true"
import script from "./DocPDF.vue?vue&type=script&lang=js"
export * from "./DocPDF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d134ac3a",
  null
  
)

export default component.exports